import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { UpdatePieceIndividual } from "src/app/parametrage/core/model/individual/update-piece-individual";

@Component({
  selector: "app-update-piece-individual",
  templateUrl: "./update-piece-individual.component.html",
  styleUrls: ["./update-piece-individual.component.scss"],
})
export class UpdatePieceIndividualComponent implements OnInit {
  @Input() individualId;

  individual: Individual;

  customer: UpdatePieceIndividual = new UpdatePieceIndividual();

  dateExpPieceJson: any;
  dateNaissanceJson: any;

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _individualService: IndividualService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      typePiece: ["", Validators.compose([Validators.nullValidator])],
      dateExpPiece: ["", Validators.compose([Validators.nullValidator])],
      dateNaissance: ["", Validators.compose([Validators.nullValidator])],
      lieuNaissance: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {
    this.getIndividualById(this.individualId);
  }

  getIndividualById(individualId) {
    this._individualService.getIndividualById(individualId).subscribe(
      (data) => {
        this.individual = data;
        this.customer.individualId = this.individual.id;
        this.customer.typePiece = this.individual.typePiece;
        this.customer.lieuNaissance = this.individual.lieuNaissance;
        this.dateExpPieceJson = this.convertDateStringToDateJson(
          this.individual.dateExpPiece
        );
        this.dateNaissanceJson = this.convertDateStringToDateJson(
          this.individual.dateNaissance
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this.customer.dateExpPiece =
      this.convertDateJsonToDateString(this.dateExpPieceJson, {
        hour: 0,
        minute: 0,
      }) + ":00Z";
    this.customer.dateNaissance =
      this.convertDateJsonToDateString(this.dateNaissanceJson, {
        hour: 0,
        minute: 0,
      }) + ":00Z";
    this._individualService
      .updatePiece(this.customer)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year + "-" + month + "-" + day + "T" + hour + ":" + minute;
    return datetime;
  }
}
